import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

export function Footer({ settings = {} }) {
  return (
    <footer className="bg-brand-purpleDeep text-white/70" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo dark />
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            Easy video. Great results. Professional video content for New Zealand businesses — without the production headache.
          </p>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold mb-4 text-sm">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/services" className="hover:text-brand-orange transition-colors">Video Services</Link></li>
            <li><Link to="/work" className="hover:text-brand-orange transition-colors">Our Work</Link></li>
            <li><Link to="/how-it-works" className="hover:text-brand-orange transition-colors">How It Works</Link></li>
            <li><Link to="/pricing" className="hover:text-brand-orange transition-colors">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold mb-4 text-sm">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-brand-orange transition-colors">About EasyVideo</Link></li>
            <li><Link to="/contact" className="hover:text-brand-orange transition-colors">Contact</Link></li>
            <li><Link to="/login" className="hover:text-brand-orange transition-colors">Client Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold mb-4 text-sm">Get in touch</h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2"><Mail size={15} className="text-brand-orange" />{settings.contact_email || "hello@easyvideo.co.nz"}</li>
            <li className="flex items-center gap-2"><Phone size={15} className="text-brand-orange" />{settings.contact_phone || "+64 21 000 0000"}</li>
          </ul>
          <Link to="/contact" className="mt-5 inline-flex items-center gap-1.5 text-brand-orange font-semibold text-sm hover:gap-2.5 transition-all">
            Start your video <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs">
          <span>© {new Date().getFullYear()} EasyVideo. Made in Aotearoa New Zealand.</span>
          <span>Video production made easy.</span>
        </div>
      </div>
    </footer>
  );
}
